import React, { useRef, useEffect } from 'react';
import { Bold, Italic, Underline, List, ListOrdered, AlignLeft, AlignCenter, AlignRight, Type } from 'lucide-react';

const RichTextEditor = ({ value, onChange, placeholder, error }) => {
  const editorRef = useRef(null);

  useEffect(() => {
    if (editorRef.current && editorRef.current.innerHTML !== value) {
      editorRef.current.innerHTML = value || '';
    }
  }, [value]);

  const executeCommand = (command, arg = null) => {
    document.execCommand(command, false, arg);
    if (editorRef.current) {
      onChange(editorRef.current.innerHTML);
    }
  };

  const handleInput = () => {
    if (editorRef.current) {
      onChange(editorRef.current.innerHTML);
    }
  };

  return (
    <div style={{
      border: error ? '1px solid #FF4D4D' : '1px solid var(--border-color)',
      borderRadius: '10px',
      overflow: 'hidden',
      background: 'white'
    }}>
      {/* Toolbar */}
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '6px',
        padding: '8px',
        borderBottom: '1px solid var(--border-color)',
        background: '#F8F9FB',
        alignItems: 'center'
      }}>
        <button type="button" onClick={() => executeCommand('bold')} style={toolbarBtnStyle} className="editor-btn" title="Bold">
          <Bold size={15} />
        </button>
        <button type="button" onClick={() => executeCommand('italic')} style={toolbarBtnStyle} className="editor-btn" title="Italic">
          <Italic size={15} />
        </button>
        <button type="button" onClick={() => executeCommand('underline')} style={toolbarBtnStyle} className="editor-btn" title="Underline">
          <Underline size={15} />
        </button>
        <div style={separatorStyle} />
        <button type="button" onClick={() => executeCommand('insertUnorderedList')} style={toolbarBtnStyle} className="editor-btn" title="Bullet List">
          <List size={15} />
        </button>
        <button type="button" onClick={() => executeCommand('insertOrderedList')} style={toolbarBtnStyle} className="editor-btn" title="Numbered List">
          <ListOrdered size={15} />
        </button>
        <div style={separatorStyle} />
        <button type="button" onClick={() => executeCommand('justifyLeft')} style={toolbarBtnStyle} className="editor-btn" title="Align Left">
          <AlignLeft size={15} />
        </button>
        <button type="button" onClick={() => executeCommand('justifyCenter')} style={toolbarBtnStyle} className="editor-btn" title="Align Center">
          <AlignCenter size={15} />
        </button>
        <button type="button" onClick={() => executeCommand('justifyRight')} style={toolbarBtnStyle} className="editor-btn" title="Align Right">
          <AlignRight size={15} />
        </button>
        <div style={separatorStyle} />
        <button type="button" onClick={() => executeCommand('removeFormat')} style={toolbarBtnStyle} className="editor-btn" title="Clear Formatting">
          <Type size={15} />
        </button>
      </div>

      {/* Editable Area */}
      <div
        ref={editorRef}
        contentEditable
        onInput={handleInput}
        placeholder={placeholder}
        style={{
          minHeight: '180px',
          maxHeight: '300px',
          overflowY: 'auto',
          padding: '16px',
          outline: 'none',
          fontSize: '14px',
          lineHeight: '1.6',
          color: 'var(--text-main)'
        }}
        className="rich-editor-content"
      />
    </div>
  );
};

const toolbarBtnStyle = {
  background: 'white',
  border: '1px solid var(--border-color)',
  borderRadius: '6px',
  width: '32px',
  height: '32px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  color: 'var(--text-secondary)',
  transition: 'all 0.2s',
  outline: 'none'
};

const separatorStyle = {
  width: '1px',
  height: '20px',
  background: 'var(--border-color)',
  margin: '0 4px'
};

export { RichTextEditor };
